(() => {
  document.querySelectorAll('[data-gameday-top25]').forEach(root => {
    if (root.dataset.initialized === 'true') return;
    const tabs = Array.from(root.querySelectorAll('[data-top25-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-top25-panel]'));
    if (!tabs.length || panels.length !== tabs.length) return;
    root.dataset.initialized = 'true';
    const select = root.querySelector('[data-top25-week-select]');
    const status = root.querySelector('[data-top25-week-status]');
    const controls = root.querySelector('[data-top25-controls]');
    const search = root.querySelector('[data-top25-search]');
    const conference = root.querySelector('[data-top25-conference]');
    const movement = root.querySelector('[data-top25-movement]');
    const sort = root.querySelector('[data-top25-sort]');
    const count = root.querySelector('[data-top25-count]');
    const empty = root.querySelector('[data-top25-empty]');
    const cardsByPanel = new Map(panels.map(panel => [panel, Array.from(panel.querySelectorAll('[data-top25-card]'))]));
    const cache = new Map();
    const hydrated = new WeakSet();
    const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const comparators = {
      rank: (a, b) => Number(a.dataset.rank) - Number(b.dataset.rank),
      rise: (a, b) => Number(b.dataset.delta) - Number(a.dataset.delta) || Number(a.dataset.rank) - Number(b.dataset.rank),
      fall: (a, b) => Number(a.dataset.delta) - Number(b.dataset.delta) || Number(a.dataset.rank) - Number(b.dataset.rank),
      team: (a, b) => a.dataset.team.localeCompare(b.dataset.team)
    };
    let activePanel = panels[0];
    const render = () => {
      const cards = cardsByPanel.get(activePanel), q = normalize(search?.value);
      const shown = cards.filter(card => (!q || normalize(`${card.dataset.team} ${card.dataset.conference}`).includes(q))
        && (!conference?.value || card.dataset.conference === conference.value)
        && (!movement?.value || card.dataset.movement === movement.value)).sort(comparators[sort?.value] || comparators.rank);
      cards.forEach(card => { card.hidden = true; });
      shown.forEach(card => { card.hidden = false; activePanel.querySelector('[data-top25-board]').append(card); });
      if (count) count.textContent = String(shown.length);
      if (empty) empty.hidden = shown.length !== 0;
    };
    const productImage = handle => {
      if (!cache.has(handle)) cache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, {headers: {Accept: 'application/json'}})
        .then(response => { if (!response.ok) throw new Error(`HTTP ${response.status}`); return response.json(); })
        .then(product => typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src || product.images?.[0]));
      return cache.get(handle);
    };
    const hydrate = async panel => {
      if (location.protocol === 'file:') return;
      const queue = cardsByPanel.get(panel).filter(card => !hydrated.has(card));
      let cursor = 0;
      const worker = async () => {
        while (cursor < queue.length) {
          const card = queue[cursor++]; hydrated.add(card);
          try {
            const source = await productImage(card.dataset.handle);
            if (!source) continue;
            const url = new URL(source, location.origin);
            if (!['http:', 'https:'].includes(url.protocol)) continue;
            url.searchParams.set('width', '560');
            const image = document.createElement('img'); image.src = url.href;
            image.alt = `${card.dataset.team} Authentic Gameday Flag`; image.loading = 'lazy'; image.decoding = 'async';
            card.querySelector('[data-top25-media]').replaceChildren(image);
          } catch (_) { /* Semantic product links remain available if media cannot load. */ }
        }
      };
      await Promise.all(Array.from({length: 5}, worker));
    };
    root.querySelector('[data-top25-tabs]').setAttribute('role', 'tablist');
    panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', `tab-${panel.id}`); });
    tabs.forEach(tab => { tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', tab.hash.slice(1)); });
    const activate = (id, push = false, focusTab = false) => {
      activePanel = panels.find(panel => panel.id === id) || panels[0];
      panels.forEach(panel => { panel.hidden = panel !== activePanel; });
      tabs.forEach(tab => {
        const selected = tab.hash.slice(1) === activePanel.id;
        tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1;
        if (selected && focusTab) tab.focus();
      });
      select.value = activePanel.id;
      status.textContent = `Viewing ${activePanel.querySelector('h2').textContent}`;
      if (push && location.hash !== `#${activePanel.id}`) {
        const url = new URL(location.href); url.hash = activePanel.id; history.pushState(null, '', url);
      }
      render(); hydrate(activePanel);
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', event => { event.preventDefault(); activate(tab.hash.slice(1), true); });
      tab.addEventListener('keydown', event => {
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
          : event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : null;
        if (target !== null) { event.preventDefault(); activate(tabs[target].hash.slice(1), true, true); }
      });
    });
    select.addEventListener('change', () => activate(select.value, true));
    const followLocation = () => activate(location.hash.slice(1));
    addEventListener('popstate', followLocation); addEventListener('hashchange', followLocation);
    if (controls) { controls.hidden = false; controls.addEventListener('submit', event => event.preventDefault()); }
    root.querySelector('[data-top25-week-control]').hidden = false;
    const results = root.querySelector('[data-top25-results]'); if (results) results.hidden = false;
    [search, conference, movement, sort].filter(Boolean).forEach(control => control.addEventListener(control === search ? 'input' : 'change', render));
    followLocation();
  });
})();
